





















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { IRule, validateRuleFilters } from '@/helpers/filter-rules'
import { TrackFields } from '@/constants'

interface IRuleLine {
  index: number
  rule: IRule
}

@Component({
  components: {
    Rule: require('./Rule').default
  }
})
export default class RuleFilter extends Vue {
  @Prop()
  value: Track[]

  @Prop()
  rules: IRule[]

  @Prop({
    required: true
  })
  target: string

  valid: boolean = true
  model: Track[] = this.value
  ruleLines: IRuleLine[] = []
  allowRulesUpdate: boolean = true

  addRule() {
    const index: number = Math.max(...this.ruleLines.map(x => x.index), 0) + 1

    this.ruleLines.push({
      index,
      rule: {
        field: TrackFields.Title,
        operator: null,
        value1: '',
        value2: null
      }
    })
  }

  removeRule(index: number) {
    const i = this.ruleLines.findIndex(x => x.index === index)

    if (i > -1) {
      this.ruleLines.splice(i, 1)
    }
  }

  validate() {
    this.valid = validateRuleFilters(this.ruleLines.map(x => x.rule))

    this.$emit('update:valid', this.valid)
  }

  created() {
    this.initRuleLines()
  }

  initRuleLines() {
    this.ruleLines = this.rules.map((rule, i) => {
      return {
        index: i,
        rule
      } as IRuleLine
    })
  }

  @Watch('rules')
  watchRules() {
    if (this.allowRulesUpdate) {
      this.initRuleLines()
    }
  }

  @Watch('model')
  watchModel(v: Track[]) {
    this.$emit('input', v)
  }

  @Watch('ruleLines', { deep: true, immediate: true })
  watchRuleLines() {
    this.validate()

    this.allowRulesUpdate = false

    const rules = this.ruleLines.map(x => x.rule)

    this.$store.commit('trackselectwizard/setRules', {
      rules,
      target: this.target
    })

    this.$emit('update:rules', rules)

    this.$nextTick(() => {
      this.allowRulesUpdate = true
    })
  }
}
